import React, { useState, useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { SuccesToast, ErrorToast } from "../../components/Toast/message";
import { AiOutlineEdit, AiOutlinePlus } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { getAllData, addData } from "../../Utility/API";
import { endPoints } from "../../constant/Environment";

const MOCK_CONFIGS = [
  {
    streak: 3,
    id: 1,
    gc: 5000,
    sc: 2,
    freeSpin: 10,
    specifications: "Login 3 days in a row to claim.",
    termsAndConditions: "Rewards expire after 24 hours.",
    exclude_player: [],
    isActive: 1,
  },
  {
    streak: 7,
    id: 2,
    gc: 15000,
    sc: 5,
    freeSpin: 25,
    specifications: "Login 7 days in a row to claim.",
    termsAndConditions: "Rewards expire after 24 hours.",
    exclude_player: [],
    isActive: 1,
  },
  {
    streak: 10,
    id: 3,
    gc: 30000,
    sc: 10,
    freeSpin: 50,
    specifications: "Login 10 days in a row to claim.",
    termsAndConditions: "Rewards expire after 24 hours.",
    exclude_player: [],
    isActive: 1,
  },
  {
    streak: 30,
    id: 4,
    gc: 100000,
    sc: 30,
    freeSpin: 150,
    specifications: "Login 30 days in a row to claim.",
    termsAndConditions: "Rewards expire after 24 hours.",
    exclude_player: [],
    isActive: 1,
  },
];

const PromotionConfig = () => {
  const [configs, setConfigs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [id, setId] = useState(0);
  const [streak, setStreak] = useState("");
  const [gc, setGc] = useState("");
  const [sc, setSc] = useState("");
  const [freeSpin, setFreeSpin] = useState("");
  const [specifications, setSpecifications] = useState("");
  const [termsAndConditions, setTermsAndConditions] = useState("");

  const [playerList, setPlayerList] = useState([]);
  const [excludePlayerTypes, setExcludePlayerTypes] = useState([]);
  const [isActive, setIsActive] = useState(1);
  const [packageList, setPackageList] = useState([]);
  const [coinPackageId, setCoinPackageId] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchConfigs();
    getPlayerTypes();
    getCoinPackageList();
  }, []);

  const getCoinPackageList = () => {
    let url = `${endPoints.api.GET_PACKAGE}`;
    getAllData(url)
      .then((response) => {
        if (response.status === "success" && response?.data?.length > 0) {
          setPackageList(
            response.data.filter((item) => item.isactive === 1)
          );
        }
      })
      .catch((err) => {
        console.error("Error fetching coin packages:", err);
      });
  };

  const getPlayerTypes = () => {
    let url = `${endPoints.api.playertypes}`;
    getAllData(url)
      .then((response) => {
        const { status, data } = response;
        if (status === "success") {
          setPlayerList(data);
        }
      })
      .catch((err) => {
        console.error("Error fetching player types:", err);
      });
  };

  const handlePlayerTypeChange = (playerId) => {
    setExcludePlayerTypes((prev) =>
      prev.includes(playerId)
        ? prev.filter((id) => id !== playerId)
        : [...prev, playerId]
    );
  };

  const fetchConfigs = async () => {
    setIsLoading(true);
    try {
      const response = await getAllData(endPoints.api.GET_STREAK_TYPES);
      const records = Array.isArray(response) ? response : response?.data;
      if (records && records.length > 0) {
        setConfigs(records);
      } else {
        setConfigs(MOCK_CONFIGS);
      }
    } catch (error) {
      console.error("Error fetching streak configs:", error);
      setConfigs(MOCK_CONFIGS);
    }
    setIsLoading(false);
  };

  const handleCreate = () => {
    setIsEditMode(false);
    setId(0);
    setStreak("");
    setGc("");
    setSc("");
    setFreeSpin("");
    setSpecifications("");
    setTermsAndConditions("");
    setExcludePlayerTypes([]);
    setIsActive(1);
    setCoinPackageId("");
    setShow(true);
  };

  const handleEdit = (row) => {
    setIsEditMode(true);
    setId(row.id);
    setStreak(row.streak);
    setGc(row.gc);
    setSc(row.sc);
    setFreeSpin(row.freeSpin);
    setSpecifications(row.specifications);
    setTermsAndConditions(row.termsAndConditions);
    setExcludePlayerTypes(row.exclude_player || []);
    setIsActive(row.isActive ?? 1);
    setCoinPackageId(row.coinPackageId ?? "");
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleUpdate = async () => {
    if (!isEditMode) {
      if (
        streak === "" ||
        gc === "" ||
        sc === "" ||
        freeSpin === "" ||
        specifications.trim() === "" ||
        termsAndConditions.trim() === "" ||
        coinPackageId === ""
      ) {
        ErrorToast("All fields are required");
        return;
      }
      if (Number(streak) <= 1) {
        ErrorToast("Streak must be more than 1 day");
        return;
      }
      const duplicate = configs.some(
        (row) => Number(row.streak) === Number(streak)
      );
      if (duplicate) {
        ErrorToast(`${streak} day streak already exists`);
        return;
      }
    }
    setIsLoading(true);
    try {
      const payload = {
        id: id,
        streak: Number(streak),
        gc: Number(gc),
        sc: Number(sc),
        freeSpin: Number(freeSpin),
        specifications: specifications,
        termsAndConditions: termsAndConditions,
        exclude_player: excludePlayerTypes,
        isActive: isActive,
        coinPackageId: coinPackageId ? Number(coinPackageId) : null,
      };

      const endpoint = isEditMode
        ? endPoints.api.UPDATE_STREAK_TYPE 
        : endPoints.api.CREATE_STREAK_TYPE;
      
      const response = await addData(endpoint, payload);
      
      if (response && response.status === 200) {
        if (isEditMode) {
          setConfigs((prev) =>
            prev.map((row) =>
              row.id === id
                ? {
                    ...row,
                    gc: Number(gc),
                    sc: Number(sc),
                    freeSpin: Number(freeSpin),
                    specifications: specifications,
                    termsAndConditions: termsAndConditions,
                    exclude_player: excludePlayerTypes,
                    isActive: isActive,
                    coinPackageId: coinPackageId ? Number(coinPackageId) : null,
                  }
                : row
            )
          );
          SuccesToast("Promotion config updated successfully");
        } else {
          fetchConfigs();
          SuccesToast("Promotion config created successfully");
        }
        setShow(false);
      } else {
        SuccesToast(isEditMode ? "Failed to update promotion config" : "Failed to create promotion config");
      }
    } catch (error) {
      console.error("Error saving streak config:", error);
      SuccesToast(isEditMode ? "Error updating promotion config" : "Error creating promotion config");
    }
    setIsLoading(false);
  };

  return (
    <>
      <Toaster />
      {isLoading && <Loader />}
      <div className="inner-space12">
        <div className="row">
          <div
            className="col-md-12"
            style={{
              display: "flex",
              justifyContent: "space-between",
              borderBottom: "1px solid #444",
              marginLeft: "15px",
              marginTop: "5px",
              marginRight: "15px",
              paddingRight: "50px",
            }}
          >
            <h3 className="mb-2 mt-2" style={{ fontFamily: "ArticulatCF-Bold" }}>
              Promotion Config
            </h3>
            <Button
              onClick={handleCreate}
              className="mb-2 mt-2"
              style={{
                background: "#04631e",
                borderColor: "#04631e",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontWeight: 600,
                borderRadius: "6px",
                padding: "6px 16px",
              }}
            >
              <AiOutlinePlus size={18} /> Create New
            </Button>
          </div>
        </div>

        <div className="container-fluid table-custom">
          <div className="row" style={{ padding: "5px 0px 20px 0px" }}>
            <div className="col-md-12">
              <TableContainer
                component={Paper}
                sx={{ borderRadius: "8px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }}
              >
                <Table
                  className="c_table"
                  size="small"
                  stickyHeader
                  sx={{ minWidth: 500 }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Streak</TableCell>
                      <TableCell align="center">GC (Gold Coins)</TableCell>
                      <TableCell align="center">SC (Saga Coins)</TableCell>
                      <TableCell align="center">Free Spin</TableCell>
                      <TableCell align="center">Recovery Package</TableCell>
                      <TableCell align="center">Active</TableCell>
                      <TableCell align="center">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(rowsPerPage > 0
                      ? configs.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                      : configs
                    ).map((row) => (
                      <TableRow
                        key={row.streak}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell align="center">
                          {row.streak} Day Streak
                        </TableCell>
                        <TableCell align="center">{row.gc}</TableCell>
                        <TableCell align="center">{row.sc}</TableCell>
                        <TableCell align="center">{row.freeSpin}</TableCell>
                        <TableCell align="center">
                          {row.coinPackageId
                            ? `$${
                                packageList.find(
                                  (pkg) => pkg.id === row.coinPackageId
                                )?.purchase_price ?? row.coinPackageId
                              }`
                            : "-"}
                        </TableCell>
                        <TableCell align="center">
                          <span
                            style={{
                              display: "inline-block",
                              padding: "3px 12px",
                              borderRadius: "12px",
                              fontSize: "12px",
                              fontWeight: 600,
                              color: row.isActive === 1 ? "#04631e" : "#a12020",
                              backgroundColor:
                                row.isActive === 1 ? "#e3f5e9" : "#fbe6e6",
                            }}
                          >
                            {row.isActive === 1 ? "Active" : "Inactive"}
                          </span>
                        </TableCell>
                        <TableCell align="center">
                          <AiOutlineEdit
                            size={18}
                            title="Edit"
                            style={{
                              cursor: "pointer",
                              color: "#04631e",
                            }}
                            onClick={() => handleEdit(row)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[10, 25, 50]}
                        colSpan={7}
                        count={configs.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: { "aria-label": "rows per page" },
                          native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{isEditMode ? 'Edit' : 'Create'} {streak} Day Streak Config</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-4">
              <Form.Group className="mb-3" controlId="streak">
                <Form.Label>Streak (Days)</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter streak days"
                  value={streak}
                  onChange={(e) => setStreak(e.target.value)}
                  disabled={isEditMode}
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="mb-3" controlId="gc">
                <Form.Label>GC (Gold Coins)</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter GC"
                  value={gc}
                  onChange={(e) => setGc(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="mb-3" controlId="sc">
                <Form.Label>SC (Saga Coins)</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter SC"
                  value={sc}
                  onChange={(e) => setSc(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="mb-3" controlId="freeSpin">
                <Form.Label>Free Spin</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter Free Spin count"
                  value={freeSpin}
                  onChange={(e) => setFreeSpin(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="mb-3" controlId="coinPackageId">
                <Form.Label>Recovery Package</Form.Label>
                <Form.Select
                  value={coinPackageId}
                  onChange={(e) => setCoinPackageId(e.target.value)}
                >
                  <option value="">Select Package</option>
                  {packageList.map((pkg) => (
                    <option key={pkg.id} value={pkg.id}>
                      ${pkg.purchase_price}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>

            <div className="col-md-12">
              <Form.Group className="mb-3" controlId="specifications">
                <Form.Label>Specifications</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  placeholder="Enter Specifications"
                  value={specifications}
                  onChange={(e) => setSpecifications(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className="col-md-12">
              <Form.Group className="mb-3" controlId="termsAndConditions">
                <Form.Label>Terms and Conditions</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  placeholder="Enter Terms and Conditions"
                  value={termsAndConditions}
                  onChange={(e) => setTermsAndConditions(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className="col-md-12">
              <Form.Group className="mb-3" controlId="isActive">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isActive === 1}
                      onChange={(e) => setIsActive(e.target.checked ? 1 : 0)}
                    />
                  }
                  label="Is Active"
                />
              </Form.Group>
            </div>

            <div className="col-md-12" style={{ marginTop: "10px" }}>
              <Form.Label style={{ fontWeight: "bold" }}>
                Exclude Player Type
              </Form.Label>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "5px",
                  backgroundColor: "#fafafa",
                }}
              >
                {playerList.map((player) => (
                  <FormControlLabel
                    key={player.id}
                    control={
                      <Checkbox
                        checked={excludePlayerTypes.includes(player.id)}
                        onChange={() => handlePlayerTypeChange(player.id)}
                      />
                    }
                    label={player.player_type}
                  />
                ))}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            onClick={handleUpdate}
            style={{ background: "#04631e", borderColor: "#04631e" }}
          >
            {isEditMode ? 'Update' : 'Create'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PromotionConfig;
